export enum ControllerPaletteColor {
  BoxShadow1 = '#00000026',
  Canary500 = '#E7A935',
  Canary900 = '#FFF8EB',

  Gray100 = '#000000', // aka PureBlack
  Gray200 = '#262626', // aka MasonBlack
  Gray300 = '#4D4D4D',
  Gray400 = '#757575',
  Gray600 = '#949494',
  Gray800 = '#CCCCCC',
  Gray900 = '#E5E5E5',
  Gray950 = '#F1F1F1', // aka FreshGray
  GrayWhite = '#FFFFFF',

  Ngb400 = '#453BB4',
  Ngb500 = '#625FFF',
  Ngb800 = '#AEACFD',
  Ngb900 = '#E7E6FE',

  Red300 = '#991700',
  Red400 = '#C0270C',
  Red500 = '#DE2D0E',
  Red900 = '#FDE3DF',

  Minty300 = '#387840',
  Minty500 = '#7AC37E',
  Minty700 = '#9CD2A0',
  Minty900 = '#D7ECD8',

  SyntaxBlue = '#6FD1E9',
  SyntaxGray = '#D4D4D9',
  SyntaxGreen = '#A7D948',
  SyntaxOrange = '#F39036',
  SyntaxPurple = '#BBA6F0',
  SyntaxRed = '#F16068',
  SyntaxYellow = '#DFD175',

  Transparent = 'transparent',
}
